<template>
  <div>
    <section class="modal-card-body has-text-left">
      <step-tracker></step-tracker>
      <h2 class="step-heading" v-t="`${langRoot}.username.title`" />
      <div class="fields">
        <div class="field">
          <label for="username-input" v-t="`${langRoot}.username.inputLabel`" />
          <input
            v-focus
            id="username-input"
            type="text"
            class="input"
            v-model="username"
            @keyup.enter="submit"
            @change="$trackEvent(pageTag, 'username_entered')"
            data-ci="pr-username-input"
          />
        </div>
      </div>
    </section>

    <footer class="modal-card-foot">
      <div class="level is-block">
        <div class="level-right is-pulled-right">
          <button
            @click="submit"
            class="btn primary"
            :class="{ 'inactive': !isValid }"
            v-t="`${langRoot}.username.nextBtn`"
            data-ci="pr-step1-next-button"
            :disabled="!isValid"
          />
        </div>
        <div class="level-left is-pulled-left">
          <button @click="cancel" class="btn is-ghost" v-t="`${langRoot}.username.cancelBtn`" />
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import {mapActions, mapMutations, mapState} from 'vuex';
import { isEmpty, trim } from 'lodash';
import StepTracker from './PasswordStepTracker';
import tracking from '@shared/mixins/tracking';

const name = 'passwordreset-start';
export default {
    name,
    componentName: name,

    mixins: [tracking],

    props: {
        langRoot: { type: String, required: true },
    },

    components: {
        [StepTracker.name]: StepTracker,
    },

    data() {
        return {
            username: '',
            valid_error: '',
        };
    },

    computed: {
        ...mapState('passwordreset', ['userName']),
        isValid() {
            return !isEmpty(trim(this.username));
        },
    },

    mounted() {},

    methods: {
        ...mapActions('passwordreset', ['checkUsername']),
        ...mapMutations('passwordreset', ['setUserName']),
        submit() {
            if (!this.isValid) {
                return;
            }

            this.$trackEvent(this.pageTag, 'next');
            this.setUserName(this.username);

            let payload = {
                username: this.username,
            };

            this.checkUsername(payload).then(() => {
                this.$router.replace({ name: 'passwordreset.security' });
            });
        },
        cancel() {
            this.$trackEvent(this.pageTag, 'cancel');
            this.$router.push({ name: 'Login' });
        },
    },
};
</script>



// WEBPACK FOOTER //
// login/Components/PasswordResetStart.vue